import { render, staticRenderFns } from "./StripQuestionEditor.vue?vue&type=template&id=128913c3&scoped=true&"
import script from "./StripQuestionEditor.vue?vue&type=script&lang=js&"
export * from "./StripQuestionEditor.vue?vue&type=script&lang=js&"
import style0 from "./StripQuestionEditor.vue?vue&type=style&index=0&id=128913c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128913c3",
  null
  
)

export default component.exports